document.addEventListener('livewire:navigated', function () {
    initializeAdditionalFilter();

    function initializeAdditionalFilter() {
        'use strict';
        $('.additionalFilter__btn').off('click.additionalFilter').on('click.additionalFilter', function () {
            var $this = $(this),
                $parent = $this.parent(),
                $content = $($this.data('content'));
            $('.additionalFilter__controls li').removeClass('active');
            $('.additionalFilter__content-item').addClass('d-none').removeClass('active');
            $parent.addClass('active');
            $content.removeClass('d-none').addClass('active');
        });
    }
    initializeAdditionalFilter();
});
